import Grid from '@mui/material/Grid2';
import { ComponentProps, ReactNode } from 'react';
import { CARDS_GRID_COLUMN_SPACING, CARDS_GRID_ROW_SPACING } from './cards-grid-config';

type GridContainerProps = ComponentProps<typeof Grid>;

export type CardsGridProps = {
  children: ReactNode;
  /**
   * Total columns. Default 12 for standard grids; use CARDS_GRID_DENSE_COLUMNS (60)
   * with CARDS_GRID_ITEM_SIZE_BY_DENSITY.
   */
  columns?: GridContainerProps['columns'];
  /** Horizontal gap between items. Defaults to CARDS_GRID_COLUMN_SPACING. */
  columnSpacing?: GridContainerProps['columnSpacing'];
  /** Vertical gap between rows. Defaults to CARDS_GRID_ROW_SPACING. */
  rowSpacing?: GridContainerProps['rowSpacing'];
};

/**
 * Shared card-list grid container: fixed row/column spacing defaults so feature
 * screens do not re-declare MUI Grid layout props.
 */
export function CardsGrid({
  children,
  columns = 12,
  columnSpacing = CARDS_GRID_COLUMN_SPACING,
  rowSpacing = CARDS_GRID_ROW_SPACING,
}: CardsGridProps) {
  return (
    <Grid container columns={columns} columnSpacing={columnSpacing} rowSpacing={rowSpacing}>
      {children}
    </Grid>
  );
}
